export default __webpack_public_path__ + "static/media/logo-wayun-privacy-plus.35ba1af1.png";